// components/ExportRealmButton.js
import React from 'react';
import { Button } from 'antd';
import { useRealmContext } from '../contexts/RealmProvider';
import { useRealmObjectContext } from '../contexts/RealmObjectProvider';   // ← grab the list
import downloadRealm from '../utility/DownloadRealmJson';                       // plain‑JS helper

const ExportRealmButton = () => {
  const { realmID }               = useRealmContext();
  const { realmObjectList }       = useRealmObjectContext();             // ← the payload

  const handleExport = () => {
    if (!realmObjectList?.length) return;                                // nothing to export
    downloadRealm(realmObjectList, realmID);                             // JSON = list only
  };

  return (
    <Button className="secondary-btn realm-form-cancel-button" onClick={handleExport}>
      Export Realm Objects as JSON file
    </Button>
  );
};

export default ExportRealmButton;
